import React from 'react';
import { Container, Stack } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import Header from '../header/header.component';
import Footer from '../footer/footer.component';
import Navbar from '../navbar/navbar.component';

import './page-layout-admin.css';

const theme = createTheme({
    typography: {
        allVariants: {
            fontFamily: "'Montserrat', sans-serif"
        }
    },
    palette: {
        primary: {
            main: '#002A4D'
        },
        green: {
            main: '#4CA341'
        },
        yellow: {
            main: '#FFAE07'
        },
        red: {
            main: '#DA1F33'
        },
        white: {
            main: '#FFFFFF'
        }
    }
});

const PageSubHeader = () => {
    const navigate = useNavigate();

    const onBrandItemClick = (item) => {
        if (!item) {
            return;
        }

        switch (item) {
            case 'dashboard':
                navigate('/', {
                    state: {
                        keyName: 'dashboard'
                    }
                });
                break;
            default:
                alert(`You clicked : ${item}.`);
        }
    };

    const onMenuItemClick = (item) => {
        if (!item) {
            return;
        }

        switch (item) {
            case 'Office Map':
                navigate('/');
                break;
            default:
                alert(`You clicked : ${item}.`);
        }
    };

    return (
        <>
            <Navbar
                brandName="Administrator"
                type="sub"
                onBrandClick={onBrandItemClick}
                onMenuItemClick={onMenuItemClick}
                menuOptions={[
                    {
                        text: 'Office Map',
                        value: 'Office Map',
                        position: 'left'
                    }
                ]}
            />
        </>
    );
};

const PageLayoutAdmin = () => {
    return (
        <Container sx={{ fontFamily: "'Montserrat', sans-serif" }} disableGutters maxWidth={false}>
            <ThemeProvider theme={theme}>
                <div className="wrapper-page">
                    <Stack direction={'column'}>
                        <div>
                            <Header />
                            {/* <PageSubHeader /> */}
                        </div>
                        <div className="wrapper-content">
                            <Outlet />
                        </div>
                    </Stack>
                    <Footer />
                </div>
            </ThemeProvider>
        </Container>
    );
};

export default PageLayoutAdmin;
